// @ts-nocheck
import React, { FunctionComponent } from 'react';
import { FieldProps, getIn } from 'formik';

// MUI
import TextField, { TextFieldProps } from '@mui/material/TextField';

// Properties
import * as styles from './FormTextField.styles';

const FormTextField: FunctionComponent<FieldProps & TextFieldProps> = props => {
    const isTouched = getIn(props.form.touched, props.field.name);
    const errorMessage = getIn(props.form.errors, props.field.name);

    const { disabled, error, helperText, field, form, ...rest } = props;

    return (
        <TextField
            sx={styles.textField}
            variant="outlined"
            size="small"
            margin="normal"
            InputLabelProps={{
                shrink: true,
            }}
            disabled={disabled ?? form.isSubmitting}
            error={error ?? Boolean(isTouched && errorMessage)}
            helperText={helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined)}
            {...rest}
            {...field}
        />
    );
};

export default FormTextField;
